import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'possessive', standalone: false })
export class PossessivePipe implements PipeTransform {
  transform(value: any): string {
    const name = (value ?? '').toString().trim();
    if (!name) {
      return '';
    }

    // If it already ends with an apostrophe, leave it as-is
    if (/['\u2019]$/.test(name)) {
      return name;
    }

    const endsWithS = name.toLowerCase().endsWith('s');
    return endsWithS ? `${name}'` : `${name}'s`;
  }
}


